import React, { useContext, useState } from 'react';
import { visitorFields } from './Visitors';
import InputBox from '../../components/Fields/Input Box/InputBox.jsx';
import "./VisitorsFields.scss";
import { styles, inputStyles, labelStyles } from './VisitorsFields';
import { BsCloudUpload } from "react-icons/bs";
import { toast } from 'react-toastify';
import axios from 'axios';
import { useRef } from 'react';
import "../../components/Fields/Upload Button/UploadFile.scss"
import { useEffect } from 'react';
import { FileUpload } from 'primereact/fileupload';
import { AppContext } from '../../context/AppContext.jsx';
import SuccessDialog from '../../components/SuccessDialog.jsx';
import { IoIosCloseCircleOutline } from 'react-icons/io';

const Visitors = () => {

    const { backendUrl } = useContext(AppContext);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [visitorsData, setVisitorsData] = useState(
        visitorFields.reduce((acc, field) => {
            acc[field.fieldName] = "";
            return acc;
        }, {})
    );
    const [errors, setErrors] = useState({})
    const fileUploadRefs = useRef({});
    const eMailpattern = /.+@.+\..+/
    const phoneNumberPattern = /^\d{10}$/
    const [selectedFiles, setSelectedFiles] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    useEffect(() => {
        visitorFields.forEach((field) => {
            if (field.type === "file") {
                fileUploadRefs.current[field.fieldName] = React.createRef();
            }
        });
    }, []);

    const handleFileSelect = (fieldName, e) => {
        const file = e.files[0];
        if (file) {
            handleChange(fieldName, file);
            setSelectedFiles(prev => ({
                ...prev,
                [fieldName]: file
            }));
        }
    };

    const handleChange = (fieldName, value) => {
        setVisitorsData((prevState) => ({
            ...prevState,
            [fieldName]: value
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: ""
        }));
    };

    const handleRemove = (fieldName) => {
        fileUploadRefs.current[fieldName]?.current?.clear();
        setSelectedFiles(prev => {
            const updated = { ...prev };
            delete updated[fieldName];
            return updated;
        });
        setVisitorsData(prev => ({
            ...prev,
            [fieldName]: null
        }));
    };

    const validateForm = () => {
        const testeMailpattern = eMailpattern.test(visitorsData.email)
        const testcontactNumberPattern = phoneNumberPattern.test(visitorsData.contactNumber)
        const error = {};
        if (!visitorsData.visitorName) {
            error.visitorName = "Required"
        }
        if (!visitorsData.contactNumber) {
            error.contactNumber = "Required"
        }
        else if (!testcontactNumberPattern) {
            error.contactNumber = "Enter 10 digit number"
        }
        if (!visitorsData.email) {
            error.email = "Required"
        }
        else if (!testeMailpattern) {
            error.email = "Invalid Pattern"
        }
        if (!visitorsData.idProof) {
            error.idProof = "Required"
        }
        if (!visitorsData.residentialAddress) {
            error.residentialAddress = "Required"
        }
        if (!visitorsData.grievance) {
            error.grievance = "Required"
        }
        if (!visitorsData.grievanceProof) {
            error.grievanceProof = "Required"
        }
        setErrors(error)
        return Object.keys(error).length === 0;
    }

    const clearForm = () => {
        setVisitorsData(
            visitorFields.reduce((acc, field) => {
                acc[field.fieldName] = field.type === "file" ? null : "";
                return acc;
            }, {})
        );
        setSelectedFiles({});
        Object.keys(fileUploadRefs.current).forEach((key) => {
            if (fileUploadRefs.current[key].current) {
                fileUploadRefs.current[key].current.clear();
            }
        });
        setErrors({})
    }

    const uploadVisitorGrievanceData = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            try {
                const formData = new FormData();
                setIsSubmitting(true);
                for (let key in visitorsData) {
                    if (visitorsData[key]) {
                        formData.append(key, visitorsData[key]);
                    }
                }
                const res = await axios.post(
                    `${backendUrl}/api/auth/uploadVisitorGrievance`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                if (res.data.success === true) {
                    setShowSuccessDialog(true);
                    clearForm();
                }

            }
            catch (error) {
                console.error('Error fetching users:', error);
                if (error.response && error.response.status === 503) {
                    toast.error("⚠️ The service is currently under maintenance. Please try again later.");
                }
                else if (!navigator.onLine) {
                    toast.error("🚫 No internet connection. Please check your network.");
                }

                else if (error.request && !error.response) {
                    toast.error("⚠️ Network issue or server is unreachable. Try again later.")
                }
                else if (error.response && error.response.status === 500) {
                    toast.error("Internal Server Error")
                    clearForm();
                }
                else {
                    console.error("Unexpected error:", error);
                    toast.error("Something went wrong.");
                }
            } finally {
                setIsSubmitting(false);
            }
        }

    };

    const firstColumnFields = visitorFields.slice(0, 4);
    const secondColumnFields = visitorFields.slice(4);

    return (
        <div className="visitorsMainContainer">

            <SuccessDialog
                visible={showSuccessDialog}
                onHide={() => setShowSuccessDialog(false)}
                header="Request Submitted"
                message="Your request has been submitted successfully!"
                buttonLabel="OK"
            />

            <form action="" className="formContainer" onSubmit={uploadVisitorGrievanceData}>
                <div className="form-grid">
                    {/* First Column */}
                    <div className="form-first-column">
                        {firstColumnFields.map((field, index) => (
                            <div key={index} className={`form-field ${field.className || ""}`}>
                                {field.type === "text" || field.type === "email" ? (
                                    <InputBox
                                        fieldName={field.fieldName}
                                        fieldType={field.type}
                                        placeholder={field.placeholder}
                                        styles={styles}
                                        inputStyles={inputStyles}
                                        labelStyles={labelStyles}
                                        customLabelName={field.customLabelName}
                                        required={field.required}
                                        value={visitorsData[field.fieldName]}
                                        handleChange={(e) => handleChange(field.fieldName, e.target.value)}
                                        hasError={!!errors[field.fieldName]}
                                        keyFilter={field.keyFilter}
                                        maxLength={field.maxLength}
                                    />
                                ) : field.type === "file" ? (
                                    <div style={styles} className="uploadFileContainer">
                                        <label htmlFor={field.fieldName}
                                            className="label"
                                            style={labelStyles}>
                                            {field.customLabelName}
                                            {field.required && <sup style={{ fontWeight: "700", color: "red", fontSize: "1.3rem" }}>*</sup>}
                                        </label>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "10px", backgroundColor: "white", borderRadius: "5px", padding: "clamp(20px, 4vw, 35px) 2px", fontFamily: "var(--font-paragraph)" }}>
                                            <div><BsCloudUpload size={26} /></div>
                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "5px", fontWeight: "600", fontFamily: "var(--font-paragraph)" }}>
                                                <div style={{ textAlign: "center" }}>Upload 1 Supported File</div>
                                                <div style={{ color: "#7f7f7f", textAlign: "center" }}>PDF, Document or Image. Max 10 MB</div>
                                            </div>
                                            <div style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "10px"
                                            }}>
                                                <FileUpload
                                                    name={field.fieldName}
                                                    mode="basic"
                                                    customUpload
                                                    accept="image/*, .pdf,.doc,.docx,.xls,.xlsx"
                                                    auto={false}
                                                    chooseLabel="Browse File"
                                                    onSelect={(e) => handleFileSelect(field.fieldName, e)}
                                                    style={inputStyles}
                                                    ref={fileUploadRefs.current[field.fieldName]}
                                                    className={errors[field.fieldName] ? 'p-invalid' : ''}
                                                />
                                                {selectedFiles[field.fieldName] && (
                                                    <div style={{
                                                        marginLeft: '-20px',
                                                        marginBottom: '40px',
                                                        cursor: "pointer",
                                                        color: "red",
                                                        zIndex: 20
                                                    }}>
                                                        <IoIosCloseCircleOutline
                                                            size={18}
                                                            style={{ cursor: "pointer", color: "#d32f2f" }}
                                                            onClick={() => {
                                                                fileUploadRefs.current[field.fieldName]?.current?.clear();
                                                                handleRemove(field.fieldName);
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ) : null}

                                {errors[field.fieldName] && (
                                    <p className="error-message">{errors[field.fieldName]}</p>
                                )}
                            </div>
                        ))}
                    </div>

                    <div className="form-second-column">
                        {secondColumnFields.map((field, index) => (
                            <div key={index} className={`form-field ${field.className || ""}`}>
                                {field.type === "text" || field.type === "email" ? (
                                    <InputBox
                                        fieldName={field.fieldName}
                                        fieldType={field.type}
                                        placeholder={field.placeholder}
                                        styles={styles}
                                        inputStyles={inputStyles}
                                        labelStyles={labelStyles}
                                        customLabelName={field.customLabelName}
                                        required={field.required}
                                        value={visitorsData[field.fieldName]}
                                        handleChange={(e) => handleChange(field.fieldName, e.target.value)}
                                        hasError={!!errors[field.fieldName]}
                                    />
                                ) : field.type === "file" ? (
                                    <div style={styles} className="uploadFileContainer">
                                        <label htmlFor={field.fieldName}
                                            className="label"
                                            style={labelStyles}>
                                            {field.customLabelName}
                                            {field.required && <sup style={{ fontWeight: "700", color: "red", fontSize: "1.3rem" }}>*</sup>}
                                        </label>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "10px", backgroundColor: "white", borderRadius: "5px", padding: "clamp(20px, 4vw, 35px) 2px", fontFamily: "var(--font-paragraph)" }}>
                                            <div><BsCloudUpload size={26} /></div>
                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "5px", fontWeight: "600", fontFamily: "var(--font-paragraph)" }}>
                                                <div style={{ textAlign: "center" }}>Upload 1 Supported File</div>
                                                <div style={{ color: "#7f7f7f", textAlign: "center" }}>PDF, Document or Image. Max 10 MB</div>
                                            </div>
                                            <div style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "10px"
                                            }}>
                                                <FileUpload
                                                    name={field.fieldName}
                                                    mode="basic"
                                                    customUpload
                                                    accept="image/*, .pdf,.doc,.docx,.xls,.xlsx"
                                                    auto={false}
                                                    chooseLabel="Browse File"
                                                    onSelect={(e) => handleFileSelect(field.fieldName, e)}
                                                    style={inputStyles}
                                                    ref={fileUploadRefs.current[field.fieldName]}
                                                    className={errors[field.fieldName] ? 'p-invalid' : ''}
                                                />
                                                {selectedFiles[field.fieldName] && (
                                                    <div style={{
                                                        marginLeft: '-20px',
                                                        marginBottom: '40px',
                                                        cursor: "pointer",
                                                        color: "red",
                                                        zIndex: 20
                                                    }}>
                                                        <IoIosCloseCircleOutline
                                                            size={18}
                                                            style={{ cursor: "pointer", color: "#d32f2f" }}
                                                            onClick={() => {
                                                                fileUploadRefs.current[field.fieldName]?.current?.clear();
                                                                handleRemove(field.fieldName);
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                                {errors[field.fieldName] && (
                                    <p className="error-message">{errors[field.fieldName]}</p>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        style={{ backgroundColor: "#0D553A", border: "none", color: "white", padding: "clamp(10px, 1.2vw, 13px) clamp(25px, 3vw, 39px)", borderRadius: "8px", cursor: "pointer", fontFamily: "var(--font-submit-button)", fontSize: "var(--font-submit-button-size)" }}>
                        {isSubmitting ? (
                            <>
                                <i className="pi pi-spin pi-spinner" style={{ marginRight: '8px' }}></i>
                                Submitting...
                            </>
                        ) : (
                            "Submit"
                        )}
                    </button>
                </div>
            </form>
        </div>
    )
}

export default Visitors;